import IntentApprovalContainer from "app/pages/sales-intelligence/sub-modules/intent/components/IntentApprovalContainer";
import useSignalExpirationHandler from "app/pages/sales-intelligence/sub-modules/signals/hooks/useSignalExpirationHandler";
import useSignalsFetch from "app/pages/sales-intelligence/sub-modules/signals/hooks/useSignalsFetch";
import SignalsManagementCommonContainer from "app/pages/sales-intelligence/sub-modules/signals/containers/SignalsManagementCommonContainer";

import { PlaybookWizardContainer } from "./PlaybookWizardContainer/PlaybookWizardContainer";

/**
 * Replaces the `withSignalsManagement` HOC to avoid a signal-source race condition.
 *
 * The HOC hardcoded `SignalSource.Platform`, whose parent-level effect would fire
 * *after* the child `usePlaybookSignalSource` hook (React fires effects bottom-up),
 * overwriting the correct `account` source back to `platform` for shared playbooks.
 *
 * Signal source is now managed exclusively by `usePlaybookSignalSource` inside
 * `PlaybookWizard`, which derives it from `isSharedWithAccount`.
 */
const PlaybookWizardSignalsHandlerContainer = () => {
    useSignalsFetch();
    useSignalExpirationHandler();

    return (
        <>
            <IntentApprovalContainer />
            <SignalsManagementCommonContainer />
            <PlaybookWizardContainer />
        </>
    );
};

export default PlaybookWizardSignalsHandlerContainer;
